export const PLACEHOLDER = '-';

export default { PLACEHOLDER };
